module.exports = __webpack_public_path__ + "img/setting.ce4b75a8.png";